import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';
import { useIsLicensed } from '@confluence/session-data/entry-points/useAccessStatus';
import { useIsNewUser } from '@confluence/targeting/entry-points/useIsNewUser';

export type UseIsEligibleRovoAnnouncement = {
	isEligible: boolean;
	loading: boolean;
	error?: Error;
};

export const useIsEligibleRovoAnnouncement = (): UseIsEligibleRovoAnnouncement => {
	const { isRovoLLMEnabled } = useSessionData();
	const isLicensed = useIsLicensed();

	const basicEligibilityMet = isRovoLLMEnabled && isLicensed && fg('aifc_onboarding_ga_enabled');

	const {
		isNewUser,
		loading: isLoadingNewUser,
		error: errorNewUser,
	} = useIsNewUser({}, !basicEligibilityMet);

	if (isLoadingNewUser) {
		return {
			isEligible: false,
			loading: true,
		};
	}

	if (errorNewUser) {
		return {
			isEligible: false,
			loading: false,
			error: errorNewUser,
		};
	}

	return {
		isEligible: basicEligibilityMet && !isNewUser,
		loading: false,
	};
};
